export class FormatDate {
  public static formatDate(date: Date, separador = '-') {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}${separador}${month}${separador}${day}`;
  }

  public static formatDateDiaFirts(date: Date, separador = '-') {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}${separador}${month}${separador}${year}`;
  }

  public static createInitDates(offsetDays: number): {
    startDate: Date;
    endDate: Date;
  } {
    const today = new Date();
    const startDate = new Date();
    startDate.setDate(today.getDate() - offsetDays);
    return { startDate: startDate, endDate: today };
  }

  public static formatDateTime(fecha: Date, separador = '-'): string {
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const año = fecha.getFullYear();
    const horas = fecha.getHours().toString().padStart(2, '0');
    const minutos = fecha.getMinutes().toString().padStart(2, '0');

    return `${dia}${separador}${mes}${separador}${año} ${horas}:${minutos}`;
  }

  public static formatearIsoParaURL(iso: string): string {
    const fecha = new Date(iso);
    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, '0');
    const day = String(fecha.getDate()).padStart(2, '0');
    const hours = String(fecha.getHours()).padStart(2, '0');
    const minutes = String(fecha.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
}
